import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Route } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import css from './index.scss';
import Header from '../../components/header/index';
import messages from './messages';
import { getLicenceCapSummary, getYearGroups } from './actions';
import TeacherRollContainer from '../teacher-roll';
import StudentRollContainer from '../student-roll';
import ClassRollContainer from '../class-roll';

class SchoolRollContainer extends Component {
    static propTypes = {
        licenceSummary: PropTypes.string,
        loadLicenceSummary: PropTypes.bool,
        isYearGroupDataLoaded: PropTypes.bool,
        selectedProduct: PropTypes.object,
        tabs: PropTypes.array,
        getLicenceCapSummary: PropTypes.func,
        getYearGroups: PropTypes.func,
        intl: intlShape.isRequired
    }

    componentDidMount() {
        if (this.props.loadLicenceSummary) {
            this.props.getLicenceCapSummary(this.props.selectedProduct.id);
        }

        if (!this.props.isYearGroupDataLoaded) {
            this.props.getYearGroups();
        }
    }

    componentWillReceiveProps(nextProps) {
        if (!this.props.loadLicenceSummary && nextProps.loadLicenceSummary) {
            this.props.getLicenceCapSummary(this.props.selectedProduct.id);
        }
    }

    render() {
        const { tabs, intl } = this.props;
        tabs[0].name = intl.formatMessage(messages.students);
        tabs[1].name = intl.formatMessage(messages.teachers);
        tabs[2].name = intl.formatMessage(messages.classes);

        return (
            <div className={css.schoolRollComponent} >
                <Header
                    headerTitle={this.props.intl.formatMessage(messages.schoolRoll)}
                    licenceSummary={this.props.licenceSummary}
                    licenceSummaryTitle={this.props.intl.formatMessage(messages.licenceSummary)}
                    tabs={tabs}
                />
                <div className={css.mainContent} >
                    <Route component={StudentRollContainer} path="/students" />
                    <Route component={TeacherRollContainer} path="/teachers" />
                    <Route component={ClassRollContainer} path="/classes" />
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        ...state,
        licenceSummary: state.schoolRoll.licenceSummary,
        licenceSummaryTitle: state.schoolRoll.licenceSummaryTitle,
        loadLicenceSummary: state.schoolRoll.loadLicenceSummary,
        tabs: state.schoolRoll.tabs.data,
        isYearGroupDataLoaded: state.schoolRoll.isYearGroupDataLoaded,
        selectedProduct: state.product
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getLicenceCapSummary,
        getYearGroups
    }, dispatch);
}

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(SchoolRollContainer));



// WEBPACK FOOTER //
// ./app/containers/school-roll/index.js